import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CalendarView } from 'angular-calendar';
import { CalendarService } from '../../calendar.service';

import moment from 'moment';

@Component({
  selector: 'calendar-navigation',
  template: `
    <c-button-group role="group">
      <button
        cButton
        color="primary"
        (click)="previous(view)">{{ 'actions.previous' | translate}}</button>
      <button
        cButton
        color="outline-secondary"
        (click)="today()">{{ 'date.today' | translate}}</button>
      <button
        cButton
        color="primary"
        (click)="next(view)">{{ 'actions.next' | translate}}</button>
    </c-button-group>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      c-button-group {
        display: flex;
        justify-content: center;
      }
      @media (min-width: 400px) {
        button {
          font-size: 12px;
        }
      }
      @media (min-width: 600px) {
        button {
          font-size: 14px;
        }
      }
    `,
  ],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendarNavigationComponent {

  @Input() view: CalendarView = this.calendarViewService.view;
  @Input() date: Date = new Date();
  @Output() navigate = new EventEmitter<Partial<{ period: string, date: Date }>>();

  protected daysInWeek = 7;

  constructor(protected calendarViewService: CalendarService) {
  }

  today() {
    this.navigate.emit({ date: new Date() });
  }

  next(view: CalendarView) {
    const date =
      view==CalendarView.Month ? moment(this.date).startOf('month').add(1,'month').toDate() :
      view==CalendarView.Week ? moment(this.date).startOf('day').add(this.daysInWeek,'days').toDate() :
      moment(this.date).add(1,'day').toDate();
    this.navigate.emit({ date });
  }

  previous(view: CalendarView) {
    const date =
      view==CalendarView.Month ? moment(this.date).startOf('month').subtract(1,'month').toDate() :
      view==CalendarView.Week ? moment(this.date).startOf('day').subtract(this.daysInWeek,'days').toDate() :
      moment(this.date).subtract(1,'day').toDate();
    this.navigate.emit({ date });
  }
}